module.exports = __webpack_public_path__ + "static/masfjordnes-hotel-story-thumbnail-5f9b65646c92b30bbe859341e0a81848.png";